import type { Buffer } from "../model/buffer";
import { lastLineIndex, lastNormalModeCol } from "../model/buffer";
import type { Cursor } from "../model/cursor";
import type { Range } from "../model/range";
import type { RegisterContent } from "../model/registers";
import { firstNonBlankCol } from "../motions/basic";
import {
  deleteCharRangeExclusive,
  deleteLineRange,
  normalizeRange,
  toExclusiveEnd,
} from "./range-edit";

export interface OperatorResult {
  readonly buffer: Buffer;
  readonly cursor: Cursor;
  readonly content: RegisterContent;
}

/** `d`: Rangeに応じてバッファを削除し、削除内容と削除後カーソルを返す。 */
export function applyDelete(buffer: Buffer, range: Range): OperatorResult {
  const { from, to } = normalizeRange(range);

  if (range.kind === "linewise") {
    const { buffer: nextBuffer, deletedLines } = deleteLineRange(buffer, from.line, to.line);
    const line = Math.min(from.line, lastLineIndex(nextBuffer));
    return {
      buffer: nextBuffer,
      cursor: { line, col: firstNonBlankCol(nextBuffer, line) },
      content: { lines: deletedLines, linewise: true },
    };
  }

  const exclusiveTo = range.kind === "inclusive" ? toExclusiveEnd(buffer, to) : to;
  const { buffer: nextBuffer, deletedLines } = deleteCharRangeExclusive(buffer, from, exclusiveTo);
  const col = Math.min(from.col, lastNormalModeCol(nextBuffer, from.line));
  return {
    buffer: nextBuffer,
    cursor: { line: from.line, col },
    content: { lines: deletedLines, linewise: false },
  };
}
